import React from 'react'
import type { BaseWeatherIconProps } from '../WeatherIcon'

const WeatherIconSun: React.FC<BaseWeatherIconProps> = ({ className = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      className={className}
    >
      <path
        d="M50.0055 40.2224C39.9417 40.2224 31.7832 48.3809 31.7832 58.445C31.7832 60.452 32.1078 62.384 32.7074 64.19H67.304C67.9035 62.384 68.228 60.452 68.228 58.445C68.228 48.3809 60.0695 40.2224 50.0055 40.2224Z"
        fill="#F9D23E"
      />
      <path d="M52.284 22H47.7285V35.6668H52.284V22Z" fill="#F9D23E" />
      <path
        d="M25.8487 31.0652L22.627 34.286L32.2894 43.9512L35.5111 40.7304L25.8487 31.0652Z"
        fill="#F9D23E"
      />
      <path
        d="M27.2273 56.167H13.5605V60.7225H27.2273V56.167Z"
        fill="#F9D23E"
      />
      <path
        d="M86.4502 56.167H72.7832V60.7225H86.4502V56.167Z"
        fill="#F9D23E"
      />
      <path
        d="M74.1655 31.0667L64.502 40.7304L67.723 43.9518L77.387 34.2879L74.1655 31.0667Z"
        fill="#F9D23E"
      />
      <path d="M88.5 60.4399H11.5V67.9399H88.5V60.4399Z" fill="#D2E0FF" />
    </svg>
  )
}

export default WeatherIconSun
